import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { dgWithReducer, DgContainer } from 'dg-utils';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import loginReducer from './loginReducer.mjs';
import userReducer from './userReducer.mjs';
import { reduxForm, Field } from 'redux-form';
import { dgInput, required, email } from 'dg-forms';
import { U as UserForm } from './user.form-377bc838.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import { verify2FASecret, generate2FASecret, login as login$1, resetPassword } from './loginActions.mjs';
import { toDataURL } from 'qrcode';
import { S as Spinner } from './spinner-bf1b67d8.js';
import { signup } from './userActions.mjs';
import '@babel/runtime/helpers/defineProperty';
import './types-0b7e03a3.js';
import 'qs';

var LoginForm = function LoginForm(props) {
  var createAccount = props.createAccount,
      setPage = props.setPage,
      handleSubmit = props.handleSubmit;
  return /*#__PURE__*/React.createElement("form", {
    className: "dg-login-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Field, {
    name: "email",
    type: "email",
    component: dgInput,
    placeholder: "Email",
    containerClass: "field-group",
    inputContainerClass: "form-input-container",
    validate: [required, email]
  }), /*#__PURE__*/React.createElement(Field, {
    name: "password",
    placeholder: "Password",
    type: "password",
    component: dgInput,
    validate: [required]
  }), /*#__PURE__*/React.createElement("div", {
    className: "field-group dg-admin-button-container"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-primary"
  }, "Login")), /*#__PURE__*/React.createElement("div", {
    className: "field-group dg-admin-button-container"
  }, createAccount ? /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setPage(3);
    },
    type: "button",
    className: "btn-secondary"
  }, "Create Account") : '', /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setPage(2);
    },
    type: "button",
    className: "btn-primary alt"
  }, "Forgot Password")));
};

var LoginForm$1 = reduxForm({
  form: 'LoginForm' // a unique identifier for this form

})(LoginForm);

var ResetForm = function ResetForm(props) {
  var handleSubmit = props.handleSubmit;
  return /*#__PURE__*/React.createElement("form", {
    className: "dg-login-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Field, {
    name: "email",
    placeholder: "Email",
    type: "email",
    component: dgInput,
    validate: [required, email]
  }), /*#__PURE__*/React.createElement("div", {
    className: "field-group"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-primary"
  }, "Reset Password")));
};

var ResetForm$1 = reduxForm({
  form: "ResetForm" // a unique identifier for this form

})(ResetForm);

var Verify2FAForm = function Verify2FAForm(props) {
  var handleSubmit = props.handleSubmit,
      pristine = props.pristine,
      submitting = props.submitting;
  return /*#__PURE__*/React.createElement("form", {
    className: "dg-login-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Field, {
    name: "token",
    type: "text",
    label: "2FA Code",
    labelClass: "required",
    component: dgInput,
    validate: [required]
  }), /*#__PURE__*/React.createElement("div", {
    className: "field-group dg-admin-button-container"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-primary",
    disabled: pristine || submitting
  }, "Verify")));
};

var Verify2FAForm$1 = reduxForm({
  form: 'Verify2FAForm'
})(Verify2FAForm);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Verify2FA = /*#__PURE__*/function (_Component) {
  _inherits(Verify2FA, _Component);

  var _super = _createSuper$1(Verify2FA);

  function Verify2FA(props) {
    var _this;

    _classCallCheck(this, Verify2FA);

    _this = _super.call(this, props);
    _this.onVerify = _this.onVerify.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Verify2FA, [{
    key: "onVerify",
    value: function onVerify(data) {
      var _this2 = this;

      var body = Object.assign(this.props.loggedInUser.user, data);
      this.props.verify2FASecret(body).then(function (res) {
        if (_this2.props.onSuccess) {
          _this2.props.onSuccess();
        } else {
          _this2.props.navigate("/admin/user");
        }
      })["catch"](function (res) {
        Swal.fire("Error", res.message, "error");
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-verify-2fa"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-verify-2fa-image"
      }, /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "unlock-alt",
        className: "svg-inline--fa fa-unlock-alt fa-w-14",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512"
      }, /*#__PURE__*/React.createElement("path", {
        className: "fa-primary",
        fill: "currentColor",
        d: "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-verify-2fa-text"
      }, /*#__PURE__*/React.createElement("p", null, "Get a verification code from your Authenticator app.")), /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-verify-2fa-form"
      }, /*#__PURE__*/React.createElement(Verify2FAForm$1, {
        onSubmit: this.onVerify
      })));
    }
  }]);

  return Verify2FA;
}(Component);

var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    loggedInUser: state.loggedInUser
  };
};

var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return {
    verify2FASecret: function verify2FASecret$1(data) {
      return dispatch(verify2FASecret(data));
    }
  };
};

var Verify2FA$1 = connect(mapStateToProps$2, mapDispatchToProps$2)(dgWithReducer(Verify2FA, "loggedInUser", loginReducer));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TwoFA = /*#__PURE__*/function (_Component) {
  _inherits(TwoFA, _Component);

  var _super = _createSuper(TwoFA);

  function TwoFA(props) {
    var _this;

    _classCallCheck(this, TwoFA);

    _this = _super.call(this, props);
    _this.state = {
      page: 1,
      qrCode: undefined
    };
    _this.generateSecret = _this.generateSecret.bind(_assertThisInitialized(_this));
    _this.setPage = _this.setPage.bind(_assertThisInitialized(_this));
    _this.getQRCode = _this.getQRCode.bind(_assertThisInitialized(_this));
    _this.onSkip = _this.onSkip.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TwoFA, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateSecret();
    }
  }, {
    key: "setPage",
    value: function setPage(page) {
      this.setState({
        page: page
      });
    }
  }, {
    key: "generateSecret",
    value: function generateSecret() {
      var _this2 = this;

      this.props.generate2FASecret(this.props.loggedInUser.user).then(function (res) {
        var _res$user, _res$user$twoFactor;

        if (res !== null && res !== void 0 && (_res$user = res.user) !== null && _res$user !== void 0 && (_res$user$twoFactor = _res$user.twoFactor) !== null && _res$user$twoFactor !== void 0 && _res$user$twoFactor.secret) {
          _this2.getQRCode(res.user.twoFactor.secret);
        }
      })["catch"](function (res) {
        console.log(res);
        Swal.fire("Error", res.message, "error");
      });
    }
  }, {
    key: "getQRCode",
    value: function getQRCode(secret) {
      var _this3 = this;

      if (secret && secret.otpauth_url) {
        toDataURL(secret.otpauth_url).then(function (url) {
          _this3.setState({
            qrCode: url
          });
        })["catch"](function (error) {
          console.log(error);
        });
      }
    }
  }, {
    key: "onSkip",
    value: function onSkip() {
      if (this.props.onSuccess) {
        this.props.onSuccess();
      } else {
        this.props.navigate("/admin/user");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "dg-admin-setup-2fa"
      }, this.state.page === 1 && /*#__PURE__*/React.createElement(DgContainer, {
        header: /*#__PURE__*/React.createElement("h2", null, "Setup 2 Step Verification"),
        content: /*#__PURE__*/React.createElement("div", {
          className: "dg-admin-setup-2fa-step-1"
        }, /*#__PURE__*/React.createElement("div", {
          className: "dg-admin-setup-2fa-text"
        }, /*#__PURE__*/React.createElement("p", null, "Using your Authenticator app of your choice (we recommend the Goole Authenticator app), add a new account, and then scan this barcode to set up your account.")), /*#__PURE__*/React.createElement("div", {
          className: "dg-admin-setup-2fa-barcode"
        }, this.state.qrCode ? /*#__PURE__*/React.createElement("img", {
          src: this.state.qrCode,
          alt: "2FA QR Code",
          height: "250px",
          width: "250px"
        }) : /*#__PURE__*/React.createElement(Spinner, null)), /*#__PURE__*/React.createElement("div", {
          className: "dg-admin-setup-2fa-button-container"
        }, this.props.allowSkip2FA ? /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn-primary alt",
          onClick: function onClick() {
            return _this4.onSkip();
          }
        }, "Skip") : "", /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn-primary",
          onClick: function onClick() {
            return _this4.setPage(2);
          }
        }, "Next")))
      }), this.state.page === 2 && /*#__PURE__*/React.createElement(DgContainer, {
        header: /*#__PURE__*/React.createElement("h2", null, "2 Step Verification"),
        content: /*#__PURE__*/React.createElement(Verify2FA$1, {
          navigate: this.props.navigate,
          onSuccess: this.props.onSuccess
        })
      }));
    }
  }]);

  return TwoFA;
}(Component);

var mapStateToProps$1 = function mapStateToProps(state) {
  var _state$loggedInUser;

  return {
    loggedInUser: state.loggedInUser,
    allowSkip2FA: (_state$loggedInUser = state.loggedInUser) === null || _state$loggedInUser === void 0 ? void 0 : _state$loggedInUser.allowSkip2FA
  };
};

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    generate2FASecret: function generate2FASecret$1(user) {
      return dispatch(generate2FASecret(user));
    }
  };
};

var Setup2FA = connect(mapStateToProps$1, mapDispatchToProps$1)(dgWithReducer(TwoFA, "loggedInUser", loginReducer));

function Login(props) {
  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var navigate = useNavigate();

  var resetPassword = function resetPassword(form) {
    props.resetPassword(form).then(function (res) {
      Swal.fire("Success!", res.message, "success");
      setPage(1);
    })["catch"](function (res) {
      Swal.fire("Error!", res.message, "error");
    });
  };

  var onSubmit = function onSubmit(form) {
    props.login(form).then(function (res) {
      console.log("RRRRRRRRRRRRRes", res);

      if (res !== null && res !== void 0 && res.is2FAEnabled) {
        var _res$user, _res$user2, _res$user3, _res$user3$twoFactor;

        if (res !== null && res !== void 0 && (_res$user = res.user) !== null && _res$user !== void 0 && _res$user.isTwoFactorEnabled && res !== null && res !== void 0 && (_res$user2 = res.user) !== null && _res$user2 !== void 0 && _res$user2.twoFactor && res !== null && res !== void 0 && (_res$user3 = res.user) !== null && _res$user3 !== void 0 && (_res$user3$twoFactor = _res$user3.twoFactor) !== null && _res$user3$twoFactor !== void 0 && _res$user3$twoFactor.isVerified) {
          setPage(4);
          console.log("IN PAGE 4");
        } else {
          setPage(5);
          console.log("IN PAGE 5");
        }
      } else {
        if (props.onSuccess) {
          props.onSuccess();
        } else {
          navigate("/admin/user");
        }
      }
    })["catch"](function (res) {
      Swal.fire("Error!", res.message, "error");
    });
  };

  var createAccount = function createAccount(form) {
    props.signup(form).then(function (res) {
      Swal.fire("Success", res.message, "success");
      setPage(1);
    })["catch"](function (res) {
      Swal.fire("Error", res.message, "error");
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "dg-admin-login-container"
  }, page === 1 && /*#__PURE__*/React.createElement(DgContainer, {
    header: /*#__PURE__*/React.createElement("h2", null, "Login"),
    content: /*#__PURE__*/React.createElement(LoginForm$1, {
      onSubmit: props.onSubmit ? props.onSubmit : onSubmit,
      createAccount: props.createAccount,
      setPage: setPage
    })
  }), page === 2 && /*#__PURE__*/React.createElement(DgContainer, {
    header: /*#__PURE__*/React.createElement("h2", null, "Password Reset"),
    content: /*#__PURE__*/React.createElement(ResetForm$1, {
      onSubmit: resetPassword
    })
  }), page === 3 && /*#__PURE__*/React.createElement(DgContainer, {
    header: /*#__PURE__*/React.createElement("h2", null, "Create Account"),
    content: /*#__PURE__*/React.createElement(UserForm, {
      onSubmit: createAccount,
      setPage: setPage
    })
  }), page === 4 && /*#__PURE__*/React.createElement(DgContainer, {
    header: /*#__PURE__*/React.createElement("h2", null, "2 Step Verification"),
    content: /*#__PURE__*/React.createElement(Verify2FA$1, {
      navigate: navigate,
      onSuccess: props.onSuccess
    })
  }), page === 5 && /*#__PURE__*/React.createElement(Setup2FA, {
    navigate: navigate,
    onSuccess: props.onSuccess
  }));
}

var mapStateToProps = function mapStateToProps(state) {
  var _state$loggedInUser;

  return {
    is2FAEnabled: (_state$loggedInUser = state.loggedInUser) === null || _state$loggedInUser === void 0 ? void 0 : _state$loggedInUser.is2FAEnabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    login: function login(data) {
      return dispatch(login$1(data));
    },
    resetPassword: function resetPassword$1(data) {
      return dispatch(resetPassword(data));
    },
    signup: function signup$1(data) {
      return dispatch(signup(data));
    }
  };
};

var login = connect(mapStateToProps, mapDispatchToProps)(dgWithReducer(dgWithReducer(Login, "loggedInUser", loginReducer), "users", userReducer));

export { login as default };
